import { useIonRouter, IonChip, useIonViewWillEnter, IonList, IonText, IonGrid, IonCol, IonCardSubtitle, IonCardContent, IonCardTitle, IonCardHeader, NavContext, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { sendOutline, logOutOutline, helpCircleOutline, clipboardOutline } from "ionicons/icons";
import { Clipboard } from '@capacitor/clipboard';
import React, { useState, useContext } from "react";
import ExploreContainer from "../components/ExploreContainer";
import { Browser } from '@capacitor/browser';

import { LANGUAGE, GetStr } from "../language/Language";
import AddressItem, { AddressData } from "../components/AddressItem";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import HelpBut from "../components/HelpBut";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  

var AddressIndex : number = 0;

const Withdraw: React.FC = () => {

    const [ address, setAddress ] = useState("");
    const [ addressList, setAddressList ] = useState<AddressData[]>([]);
    const [ canWithdraw, setCanWithdraw] = useState(false);
    const [ seeMoreAdd, setSeeMoreAdd ] = useState(true);

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        AddressIndex = 0;
        getData();
    });

    // query
    const getData = async () => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: AddressIndex,
            e: 2
        }

		var server = new NServer();
        await server.getList("withdraw_query", state);
        if (server.success)
        {
            setCanWithdraw(server.data.can == "yes");

            if (AddressIndex == 0)
                setAddressList(server.data.addresses);
            else
		        setAddressList(addressList.concat(server.data.addresses));

            // if we reach end of data
            if (server.data.addresses.length < 2)
                setSeeMoreAdd(false);
        }
	}

    const getMoreAddress = () => {
        AddressIndex += 2;
        getData();
    }

    const clickAddress = (add : string) => {
        setAddress(add);
    }

    const doWithdraw = () => {
        if (address.length < 30)
        {
            showAlert(GetStr(LANGUAGE.TXT_WIDTHDRAW_INVALD_ADD));
            return;
        }
        
        router.push('/withdraw_amt/' + address, "forward", "push");
    };

    // handle the user input
    const updateAddress = (e : any ) : void => {
        setAddress(e.detail.value.toString());
    };

    const doPaste = async () => {
        const { type, value } = await Clipboard.read();
        setAddress(value);
    };

    const showHow = async () => {
        await Browser.open({ url: 'https://nwallet.me/d/help.php?d=cryptowidthdraw' });
    }

    const quickWithdraw = () => {
        router.push("/quick_withdraw", "forward", "push");
    }
     
    return (
        <IonPage>
            <IonHeader>
            </IonHeader>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <HelpBut topic="cryptowidthdraw" />
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonCard className="ion-padding flat-card">
                                <IonCardHeader>
                                    <IonCardSubtitle>
                                        <b>{ GetStr(LANGUAGE.TXT_WIDTHDRAW_INFO) }</b>&nbsp;&nbsp;
                                        {/* <IonChip color="secondary" onClick={quickWithdraw}><b>{ GetStr(LANGUAGE.TXT_QUICK_WITHDRAW) }</b></IonChip> */}
                                    </IonCardSubtitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <IonItem>
                                        <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_WIDTHDRAW_LBL) }</IonLabel>
                                        <IonInput name="address" placeholder="xxxx-xxxx-xxxx" value={address} onIonChange={updateAddress}>
                                        </IonInput>
                                        <IonIcon icon={clipboardOutline} slot="end" onClick={doPaste} />
                                    </IonItem>
                                    <IonButton className="ion-margin-top main-but" color="primary" expand="block" onClick={doWithdraw} disabled={!canWithdraw} >
                                        <IonIcon slot="start" icon={logOutOutline}/>
                                        { GetStr(LANGUAGE.TXT_WIDTHDRAW_DO) }
                                    </IonButton>
                                    <IonButton className="ion-margin-top main-but" color="secondary" expand="block" onClick={showHow} >
                                        <IonIcon slot="start" icon={helpCircleOutline}/>
                                        { GetStr(LANGUAGE.TXT_WIDTHDRAW_HOW) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                            {
                                addressList.length > 0 ?
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <IonText>{ GetStr(LANGUAGE.TXT_LAST_WITHDRAW_ADD) }</IonText>
                                    { addressList.map(m => <AddressItem key={m.id} address={m} onClick={ clickAddress } />) }
                                    {
                                        seeMoreAdd ?

                                    <IonButton className="main-but" color="secondary" expand="block" fill="clear" onClick={getMoreAddress} >
                                        <b>{ GetStr(LANGUAGE.TXT_WITHDRAW_ADD_SEEMORE) }</b>
                                    </IonButton>
                                        :
                                    <div/>
                                    }
                                </IonCardContent>
                            </IonCard>
                                :
                            <div/>
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage >
    );
};
export default Withdraw;